module.exports = "/_next/static/images/ico-note-add-blue-b12f27885741057ea3ccb11af3ad9386.svg";